import * as Yup from 'yup';
export const initialHealthCareWorkerValues = {
    consentForPhoto: false,
    languageId: '',
    teamLeadId: '',
    clickedContactTab: false,
    clickedDashboardClientsTab: false,
    clickedDashboardClientsTabB: false,
    clickedDashboardHighlightsTab: false,
    clickedDashboardVisitsTab: false,
    clickedProgressTab: false,
    clickedReferralsTab: false,
    clickedTeamTab: false,
    clickedVisitTab: false,
    isNewAtClinic: true,
    shareContactInfo: false,
    welcomeMessage: '',
};
export const healthCareWorkerSchema = Yup.object().shape({
    consentForPhoto: Yup.bool(),
    languageId: Yup.string(),
    teamLeadId: Yup.string(),
});
//# sourceMappingURL=health-care-worker.js.map